<div class="layout-wrapper"  (click)="onLayoutClick()"
     [ngClass]="{'layout-static': app.menuMode === 'static',
                'layout-overlay': app.menuMode === 'overlay',
                'layout-slim': app.menuMode === 'slim',
                'layout-horizontal': app.menuMode === 'horizontal',
                'layout-sidebar': app.menuMode === 'sidebar',
                'layout-sidebar-static': app.menuMode === 'sidebar' && sidebarStatic,
                'layout-overlay-active': overlayMenuActive,
                'layout-mobile-active': staticMenuMobileActive,
                'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
                 'p-ripple-disabled': !app.ripple}">

    <div class="layout-main">
        
        <app-menu *ngIf="!isMobile() && (isStatic() || isSlim() || isSidebar())"></app-menu>

        <app-breadcrumb></app-breadcrumb>

        <div class="oris-layout layout-main-content">
            <router-outlet></router-outlet>
            <p-dialog [closable]="false" [(visible)]="displayModalNotDocumentFound" [modal]="true" [breakpoints]="{'960px': '70vw', '560px': '90vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000"
                [draggable]="false" [resizable]="false">
                <p-header class="title-already-signed">{{ 'titleDocumentNotFounded' | translate }}</p-header>
                <p class="message-already-signed">{{ 'messageDocumentNotFounded' | translate }}</p>
                <ng-template pTemplate="footer">
                    <p-button (click)="closeModalNotDocumentFound()" label="{{'documentSign.okButton' | translate}}" class="p-button-text"></p-button>
                </ng-template>
            </p-dialog>
        </div>

        <app-footer></app-footer>
    </div>
</div>
